"use strict";

require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitFormatString = exports.parseValue = exports.displayFormatString = exports["default"] = void 0;
Object.defineProperty(exports, "validations", {
  enumerable: true,
  get: function get() {
    return _validations["default"];
  }
});
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
require("core-js/modules/es.date.to-string.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMedia = _interopRequireDefault(require("react-media"));
var _dateFns = require("date-fns");
var _formElements = require("@evidation/form-elements");
var _utils = require("../utils");
var _mobile = _interopRequireDefault(require("./mobile"));
var _date = _interopRequireDefault(require("../date"));
var _datePicker = _interopRequireDefault(require("../../components/datePicker"));
var _lodash = _interopRequireDefault(require("lodash"));
var _useTranslated = require("../../hooks/useTranslated");
var _validations = _interopRequireDefault(require("./validations"));
var _excluded = ["mobile", "label", "dob_format", "input"];
var submitFormatString = exports.submitFormatString = function submitFormatString(dob_format) {
  switch (dob_format) {
    case 'YYYY-MM':
      return 'yyyy-MM';
    case 'YYYY':
      return 'yyyy';
    case 'MM-DD-YYYY':
      return 'MM-dd-yyyy';
    case 'YYYY-MM-DD':
    default:
      return 'yyyy-MM-dd';
  }
};
var displayFormatString = exports.displayFormatString = function displayFormatString(dob_format) {
  switch (dob_format) {
    case 'YYYY-MM':
      return 'yyyy-MMM';
    case 'YYYY':
      return 'yyyy';
    case 'MM-DD-YYYY':
      return 'MM-dd-yyyy';
    case 'YYYY-MM-DD':
    default:
      return 'yyyy-MMM-dd';
  }
};
var parseValue = exports.parseValue = function parseValue(value) {
  return (0, _dateFns.toDate)(Date.parse(value));
};
var formatSubmit = function formatSubmit(dob_format) {
  return function (date) {
    return (0, _dateFns.format)(date, submitFormatString(dob_format));
  };
};
var formatDisplay = function formatDisplay(dob_format) {
  return function (date) {
    return (0, _dateFns.format)(date, displayFormatString(dob_format));
  };
};
var DOB = function DOB(_ref) {
  var mobile = _ref.mobile,
    label = _ref.label,
    dob_format = _ref.dob_format,
    input = _ref.input,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var yearOfBirthText = (0, _useTranslated.useTranslated)('fields.dob.yearOfBirth');
  var monthOfBirthText = (0, _useTranslated.useTranslated)('fields.dob.monthYearBirth');
  var dateOfBirthText = (0, _useTranslated.useTranslated)('fields.dob.dateOfBirth');
  var labelText = function labelText(dob_format) {
    switch (dob_format) {
      case 'YYYY':
        return yearOfBirthText;
      case 'YYYY-MM':
        return monthOfBirthText;
      default:
        return dateOfBirthText;
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_formElements.InputLabel, {
    label: labelText(dob_format),
    "data-test-id": "t-dob-".concat(input.name)
  }, /*#__PURE__*/_react["default"].createElement(_reactMedia["default"], {
    queries: _utils.ReactMediaQueries
  }, function (matches) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (matches.mobile || mobile) && /*#__PURE__*/_react["default"].createElement(_mobile["default"], (0, _extends2["default"])({}, props, input, {
      dateFormat: dob_format,
      placeholder: dob_format,
      formatDisplay: formatDisplay(dob_format),
      formatSubmit: formatSubmit(dob_format),
      parseValue: parseValue
    })), matches.desktop && !mobile && ['YYYY-MM-DD', 'MM-DD-YYYY'].includes(dob_format) && /*#__PURE__*/_react["default"].createElement(_date["default"], (0, _extends2["default"])({}, props, input, {
      placeholder: dob_format,
      formatDisplay: formatDisplay(dob_format),
      formatSubmit: formatSubmit(dob_format),
      submitFormatString: submitFormatString(dob_format)
    })), matches.desktop && !mobile && _lodash["default"].includes(['YYYY-MM', 'YYYY'], dob_format) && /*#__PURE__*/_react["default"].createElement(_datePicker["default"], (0, _extends2["default"])({}, props, {
      input: input,
      dateFormat: dob_format,
      parseValue: parseValue
    })));
  }));
};
DOB.defaultProps = {
  mobile: false,
  input: {},
  dob_format: 'YYYY-MM-DD'
};
DOB.propTypes = {
  input: _propTypes["default"].shape({
    onChange: _propTypes["default"].func.isRequired,
    onBlur: _propTypes["default"].func,
    onFocus: _propTypes["default"].func
  }),
  dob_format: _propTypes["default"].oneOf(['YYYY-MM-DD', 'MM-DD-YYYY', 'YYYY-MM', 'YYYY'])
};
var _default = exports["default"] = DOB;